import * as React from "react";

const Seo = ({ seo }) => {
  return (
    <>
      <title>{seo?.metaTitle}</title>
      <meta name="description" content={seo?.metaDescription} />
      <meta property="og:image" content={seo?.metaImage.localFile.url} />
      <meta name="Keywords" content={seo?.keywords} />
      <meta name="robots" content={seo?.metaRobots} />
      <meta name="viewport" content={seo?.metaViewport} />
      <link rel="canonical" href={seo?.canonicalURL} />
      <meta property="og:type" content="website" />

      {seo?.metaSocial.map((social, index) => {
        return (
          <>
            <meta
              name={`${social.socialNetwork}:title`}
              content={social.title}
            />
            <meta
              name={`${social.socialNetwork}:description`}
              content={social.description}
            />
            <meta name={`${social.socialNetwork}:card`} content="summary" />
            <meta property="og:title" content={social.title} />
            <meta property="og:description" content={social.description} />,
          </>
        );
      })}
    </>
  );
};

export default Seo;
